'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tipoMensajeAlerta = require('../../constantes/tipoMensajeAlerta');

var _Message = require('primereact/components/message/Message');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MensajeAlertaInline = function MensajeAlertaInline(_ref) {
  var _ref$tipoMensaje = _ref.tipoMensaje,
      tipoMensaje = _ref$tipoMensaje === undefined ? _tipoMensajeAlerta.INFO : _ref$tipoMensaje,
      _ref$titulo = _ref.titulo,
      titulo = _ref$titulo === undefined ? '' : _ref$titulo,
      detalle = _ref.detalle;
  return _react2.default.createElement('div', null, _react2.default.createElement(_Message.Message, {
    severity: tipoMensaje,
    summary: titulo,
    text: detalle
  }));
};

MensajeAlertaInline.propTypes = process.env.NODE_ENV !== "production" ? {
  tipoMensaje: _propTypes2.default.string,
  detalle: _propTypes2.default.string.isRequired
} : {};
exports.default = MensajeAlertaInline;
module.exports = exports['default'];